import LocationPage from '../LocationPage';

export default function MiamiPage() {
  return (
    <LocationPage
      data={{
        slug: 'miami',
        city: 'Miami',
        metro: 'Miami-Dade County',
        headline: "Miami's AI Marketing Experts for Home-Service Contractors",
        subhead:
          'Get recommended by ChatGPT, run profitable OpenAI ads, and capture every storm lead with 24/7 Voice AI — built for Miami roofers, HVAC, and remodelers.',
        population: '2.7 million',
        neighborhoods: ['Brickell', 'Coral Gables', 'Kendall', 'Doral', 'Coconut Grove'],
        stormAngle:
          "Miami-Dade takes the first hit every hurricane season. When a storm rolls through Kendall or Cutler Bay, thousands of homeowners grab their phones at once — and they're increasingly asking ChatGPT and Google's AI for an emergency roofer before they dial. The contractors who win the post-storm surge aren't the biggest; they're the ones AI already trusts and whose phones answer on the first ring. We make sure that's you: AI-visible before the storm, and backed by a Voice AI agent that books inspections at 2am when your competitors go to voicemail.",
        whyLocal: [
          'Miami is one of the most competitive home-services markets in the country. Paid ads are expensive and crowded — GEO lets you show up in ChatGPT answers where your competitors have zero presence.',
          "Hialeah, Doral, and Brickell buyers research in English and Spanish. Our AI funnels and Voice AI handle bilingual intent so you don't lose Miami's huge Hispanic market.",
          "High-ticket coastal work (tile roofs, impact windows, luxury remodels) means one captured lead can be worth $20K+. Missing after-hours calls in Miami is the most expensive mistake a contractor makes.",
        ],
        verticals: ['Roofing', 'HVAC & A/C', 'Impact Windows & Doors', 'Remodeling', 'Pool & Outdoor'],
        faqs: [
          {
            q: 'How do you get my Miami business recommended by ChatGPT?',
            a: "Through Generative Engine Optimization (GEO). We structure your web presence, reviews, and entity data so AI engines like ChatGPT, Perplexity, and Gemini understand exactly who you are, what you do, and which Miami neighborhoods you serve — then cite you when locals ask for a recommendation.",
          },
          {
            q: 'Do ChatGPT ads actually work for Miami contractors?',
            a: "We build conversion-tracked ad funnels designed for the AI-search era — answer-first landing pages, schema, and offers that convert the high-intent traffic AI platforms send you. As OpenAI's ad placements roll out, your business is already positioned to profit from day one.",
          },
          {
            q: 'What does Voice AI do for a Miami roofing or HVAC company?',
            a: 'Our 24/7 Voice AI receptionist answers every call, qualifies the lead, books the inspection on your calendar, and logs it to your CRM — in English or Spanish. After a Miami storm, it handles the surge no human team could keep up with.',
          },
          {
            q: 'How fast can we start and what does the free audit include?',
            a: "The free AI Marketing Audit shows whether ChatGPT currently recommends you, how you stack up against your top Miami competitors, your GEO gaps, and your missed-call revenue leak. Most clients are live inside week one. Message us on WhatsApp at (954) 296-4896 to start.",
          },
        ],
        lat: 25.7617,
        lng: -80.1918,
      }}
    />
  );
}
